import { FC, useEffect } from 'react';

import Alerts from 'app/components/layout/Alerts';
import RouteListener from 'app/components/providers/RouteListener';
import { useResizableWindow } from 'app/hooks';
import { getDeviceFromWidth } from 'app/state/GeneralContext/helpers';
import { useGeneralDispatch, useGeneralState } from 'app/state/GeneralContext/hooks';

import { useAppRoutes } from './hooks';
import { MainLayout } from './MainLayout';

// Component Definition
const AppRoutes: FC = () => {
  const generalDispatch = useGeneralDispatch();
  const { currentDevice } = useGeneralState();
  const windowSize = useResizableWindow();

  useEffect(() => {
    const deviceFromWindowSize = getDeviceFromWidth(windowSize.width);

    if (currentDevice !== deviceFromWindowSize) {
      generalDispatch({
        payload: { currentDevice: deviceFromWindowSize },
        type: 'setDevice',
      });
    }
  },
  [currentDevice, generalDispatch, windowSize.width]);

  const appRoutes = useAppRoutes();

  return (
    <Alerts>
      <RouteListener>
        <MainLayout>
          {appRoutes}
        </MainLayout>
      </RouteListener>
    </Alerts>
  );
};

export default AppRoutes;
